import { createTheme } from "@mui/material/styles";

const scribeTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#1a2166", contrastText: "#ffffff" },
    secondary: { main: "#0576b8" },
    background: { default: "#ffffff", paper: "#f0f2f5" },
    text: { primary: "#1a2166", secondary: "#4a5078" },
    error: { main: "#d93025" },
    warning: { main: "#d4890a" },
    success: { main: "#1a9d5a" },
    divider: "rgba(0,0,0,0.08)",
  },
  typography: {
    fontFamily: "'DM Sans', sans-serif",
    h1: { fontFamily: "'Syne', sans-serif", fontWeight: 700 },
    h2: { fontFamily: "'Syne', sans-serif", fontWeight: 700 },
    h3: { fontFamily: "'Syne', sans-serif", fontWeight: 700 },
    h4: { fontFamily: "'Syne', sans-serif", fontWeight: 700 },
    h5: { fontFamily: "'Syne', sans-serif", fontWeight: 700 },
    h6: { fontFamily: "'Syne', sans-serif", fontWeight: 600 },
    button: { fontWeight: 600, textTransform: "none" },
  },
  shape: { borderRadius: 16 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: "#ffffff",
          border: "1px solid rgba(0,0,0,0.08)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          background: "#1a2166",
          color: "#ffffff",
          boxShadow: "0 2px 8px rgba(26,33,102,0.15)",
          "&:hover": {
            background: "#0f1450",
            boxShadow: "0 4px 16px rgba(26,33,102,0.25)",
          },
          "&:disabled": {
            background: "#dce0e8",
            color: "#b0b4c4",
            boxShadow: "none",
          },
        },
        outlined: {
          borderColor: "rgba(0,0,0,0.15)",
          color: "#4a5078",
          "&:hover": {
            borderColor: "#1a2166",
            color: "#1a2166",
            backgroundColor: "rgba(26,33,102,0.04)",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#ffffff",
            borderRadius: 10,
            "& fieldset": { borderColor: "rgba(0,0,0,0.15)" },
            "&:hover fieldset": { borderColor: "rgba(26,33,102,0.4)" },
            "&.Mui-focused fieldset": {
              borderColor: "#1a2166",
              boxShadow: "0 0 0 3px rgba(26,33,102,0.08)",
            },
          },
          "& .MuiInputBase-input": { color: "#1a2166", caretColor: "#1a2166" },
          "& .MuiInputLabel-root": { color: "#7a8098" },
          "& .MuiInputLabel-root.Mui-focused": { color: "#1a2166" },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#7a8098",
          "&.Mui-checked": { color: "#1a2166" },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          "&.Mui-checked": {
            color: "#1a2166",
            "& + .MuiSwitch-track": { backgroundColor: "rgba(26,33,102,0.35)" },
          },
        },
        track: { backgroundColor: "#ccd1dc" },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: "'DM Sans', sans-serif",
          fontSize: "0.82rem",
          fontWeight: 700,
          color: "#7a8098",
          textTransform: "none",
          flex: 1,
          minWidth: 0,
          borderRadius: 16,
          padding: "0.55rem 0.9rem",
          transition: "all 0.2s cubic-bezier(0.4,0,0.2,1)",
          "&:hover": { color: "#4a5078", backgroundColor: "#e8eaef" },
          "&.Mui-selected": {
            background: "#1a2166",
            color: "#ffffff",
            boxShadow: "0 2px 12px rgba(26,33,102,0.2)",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          padding: 4,
          backgroundColor: "#f0f2f5",
          border: "1px solid rgba(0,0,0,0.08)",
          minHeight: "unset",
        },
        indicator: { display: "none" },
        flexContainer: { gap: 4 },
      },
    },
    MuiDivider: {
      styleOverrides: { root: { borderColor: "rgba(0,0,0,0.08)" } },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#1a2166",
          color: "#ffffff",
          border: "none",
          fontSize: "0.78rem",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: { backgroundColor: "#ffffff" },
        icon: { color: "#7a8098" },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&:hover": { backgroundColor: "rgba(26,33,102,0.06)" },
          "&.Mui-selected": {
            backgroundColor: "rgba(26,33,102,0.10)",
            "&:hover": { backgroundColor: "rgba(26,33,102,0.14)" },
          },
        },
      },
    },
  },
});

export default scribeTheme;
